import { NavLink, useLocation } from "react-router";
import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarGroup,
	SidebarGroupLabel,
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarRail,
	useSidebar,
} from "@/components/ui/sidebar";
import { type NavItem, navGroups, settingsItem } from "@/config/nav";

// Adapted from connect-v2's AppSidebar: no tenants, roles or collapsible
// sub-menus; next/link → NavLink. Desktop only; phones use BottomNav.
function NavEntry({ item }: { item: NavItem }) {
	const { pathname } = useLocation();
	const active = pathname === item.url || pathname.startsWith(`${item.url}/`);
	return (
		<SidebarMenuItem>
			<SidebarMenuButton asChild tooltip={item.title} isActive={active}>
				<NavLink to={item.url}>
					<item.icon />
					<span>{item.title}</span>
				</NavLink>
			</SidebarMenuButton>
		</SidebarMenuItem>
	);
}

export function AppSidebar() {
	const { state } = useSidebar();

	return (
		<Sidebar collapsible="icon">
			<SidebarHeader>
				<div className="flex h-10 items-center gap-2 px-1">
					<div className="bg-primary text-primary-foreground flex size-7 shrink-0 items-center justify-center rounded-md text-sm font-bold">
						M
					</div>
					{state === "expanded" && <span className="truncate font-semibold">MOS</span>}
				</div>
			</SidebarHeader>
			<SidebarContent>
				{navGroups.map((group) => (
					<SidebarGroup key={group.label}>
						<SidebarGroupLabel>{group.label}</SidebarGroupLabel>
						<SidebarMenu>
							{group.items.map((item) => (
								<NavEntry key={item.url} item={item} />
							))}
						</SidebarMenu>
					</SidebarGroup>
				))}
			</SidebarContent>
			<SidebarFooter>
				<SidebarMenu>
					<NavEntry item={settingsItem} />
				</SidebarMenu>
			</SidebarFooter>
			<SidebarRail />
		</Sidebar>
	);
}
